import { Utils } from '@sparrow-marketing/contracts/lib';
import { atom } from 'recoil';
import { IReportField } from '..';

export const ReportFieldState = atom<IReportField>({
  key: 'report-field',
  default: {
    name: '',
    datasources: [],
    reportFormat: {},
    destination: {},
    badge: true,
    dateRanges: {},
  },
});

export const IsReportDatasourceDisableState = atom<boolean>({
  key: 'is-report-data-source-disable',
  default: false,
});

export const TemplateFormattedDocProps = atom<Utils.DynamicObject>({
  key: 'template-formatted-doc-props',
  default: {},
});
